import React from 'react';
import { formatAction } from './helpers';

const PatternBreadcrumb: React.FC<{ pattern: string }> = ({ pattern }) => {
  const parts = pattern.split(' -> ');
  return (
    <div className="flex flex-wrap items-center gap-1">
      {parts.map((part, idx) => {
        const isGoal = part.includes('goal');
        return (
          <React.Fragment key={`${part}-${idx}`}>
            {idx > 0 && (
              <svg className="w-3 h-3 text-gray-400 dark:text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            )}
            <span className={`text-xs px-1.5 py-0.5 rounded ${
              isGoal
                ? 'bg-green-600 text-white font-medium'
                : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400'
            }`}>
              {formatAction(part)}
            </span>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default PatternBreadcrumb;
